{
  "version": 1,
  "asset_id": "5638c1d4-8f3e-4d01-963a-0a23b8eb83e3",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/5638c1d4-8f3e-4d01-963a-0a23b8eb83e3/metal-roof-installation-citrus-county-fl-1024.avif",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/5638c1d4-8f3e-4d01-963a-0a23b8eb83e3/metal-roof-installation-citrus-county-fl-1024.avif",
  "original_filename": "metal-roof-installation-citrus-county-fl-1024.avif",
  "size": 66711,
  "content_type": "image/avif",
  "created_at": "2026-07-16T15:35:48Z"
}
